import React from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import { VentLogo } from "./VentLogo";
import Footer from "./Footer";
import TherapistFooter from "./TherapistFooter";
import { useNativePlatform } from "@/hooks/useNativePlatform";

const Layout = () => {
  const isNative = useNativePlatform();
  const location = useLocation();
  const isLandingPage = location.pathname === "/" || location.pathname === "/auth";
  const isTherapistRoute = location.pathname.startsWith("/therapist");

  // Don't show app layout on landing and auth pages - they handle their own layout
  if (isLandingPage) {
    return <Outlet />;
  }

  return (
    <div className="min-h-screen bg-gradient-soft flex flex-col">
      {/* Header */}
      <header className="border-b border-border/50 bg-background/95 backdrop-blur-sm dark:bg-background dark:backdrop-blur-none sticky top-0 z-50">
        <div className="container mx-auto px-4 py-0.5 flex items-center justify-between">
          <Link to={isTherapistRoute ? "/" : "/"} className="flex items-center gap-2">
            <VentLogo />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 pb-16">
        <Outlet />
      </main>

      {/* Footer - only show on web, not in native app (landing page has its own) */}
      {!isNative && (isTherapistRoute ? <TherapistFooter /> : <Footer />)}
    </div>
  );
};

export default Layout;